// Module exports for types
export interface SelectItem {
  key: string;
  text: string;
  value?: string | number;
  data?: any;
  disabled?: boolean;
  itemType?: any;
  selected?: boolean;
  Icon?: JSX.Element;
  [x: string]: any;
}

export interface IFile {
  name: string;
  size: number;
  type: string;
  content?: string | ArrayBuffer | null;
  lastModified?: number;
  lastModifiedDate?: Date;
  webkitRelativePath?: string;
  path?: string;
  base64Str?: string;
}

export interface INotification {
  id: string;
  message: string;
  type?: "info" | "warning" | "error" | "success";
  title?: string;
  timestamp?: number;
  autoClose?: boolean;
  isPersistent?: boolean;
  handleClearNotification?: (message: INotification) => void;
  text?: string;
}

export interface IUser {
  id: string;
  name: string;
  displayName?: string;
  email?: string;
  photoSmall?: string;
  photoLarge?: string;
  photoMedium?: string;
  roles?: string[];
  settings?: any;
  preferences?: any;
  groups?: string[];
}

export enum EAppSettings {
  THEME = "Theme",
  LANGUAGE = "Language",
  DARK_MODE = "Dark_Mode",
  NOTIFICATIONS = "Notifications",
  ACCESSIBILITY = "Accessibility",
  BENEFIT_VIEW_MODE = "Benefit_View_Mode",
}

export interface IFormattedFile {
  file: File;
  preview: string;
  status?: string;
  progress?: number;
  error?: string;
  id?: string;
  name?: string | null;
  path?: string | null;
  base64String?: string | null;
  type?: string | null;
}

export interface IFormattedFileExtended extends IFormattedFile {
  isAttachHiddenForEmployee: boolean;
}

export interface IAzureSearchData {
  id: string;
  key?: string;
  value?: string;
  score?: number;
  metadata?: any;
  content?: string;
  highlight?: string;
  source?: string;
}

export enum EBenefitTab {
  BASIC = "basic",
  ADDITIONAL = "additional",
  OPTIONAL = "optional",
  BUNDLED = "bundled",
}

export interface ITaxonomy {
  id: string;
  code: string;
  name: string;
  description?: string;
  parent?: string;
  path?: string;
  level?: number;
  isActive?: boolean;
  properties?: Record<string, any>;
  order?: number;
}

export type TaxonomyKey = string;

export interface Taxonomy {
  id: string;
  code: string;
  name: string;
  description?: string;
  parent?: string;
  path?: string;
  level?: number;
  isActive?: boolean;
  properties?: Record<string, any>;
  order?: number;
}

export interface IUserSettings {
  id?: string;
  userId?: string;
  appId?: string;
  settingId?: string;
  settingName?: string;
  settingValue?: string;
  isActive?: boolean;
  userAppSettingName?: string;
}

export interface IUserSettingsPayload {
  userId?: string;
  appId?: string;
  settingId?: string;
  settingName?: string;
  settingValue?: string;
  userAppSettingName?: string;
  applicationCodeId?: string | number;
  userAppSettingValue?: string;
  appSettingCodeId?: string | number;
  isDefault?: boolean;
}

export interface IAzureSearchResult {
  id: string;
  score: number;
  metadata?: any;
  content?: string;
  highlight?: string;
  source?: string;
  key?: string;
  value?: string;
  title?: string;
  url?: string;
}

export interface IBackendError {
  status: number;
  statusText?: string;
  data?: any;
  message?: string;
  code?: string;
  url?: string;
  errors?: Record<string, string[]>;
  statusCode?: number;
  errorCode?: string;
  type?: string;
  correlationID?: string;
  messageCode?: string;
  messageVariables?: any[];
  statusDescription?: string;
  formatedMessage?: string;
  exceptionMessage?: string;
  stackTrace?: string;
}

export interface INotify {
  notifyText: string;
  type: string;
  notifyCode: string;
  label: string;
}

export interface IErrorHandler {
  value: string;
  type: string;
  label: string;
  fieldName?: string;
  errors?: any;
}

export enum ECheckedValue {
  Yes = "yes",
  No = "no",
}

export enum EPaidBy {
  Percentage = "Percentage",
  Amount = "Amount",
}

export enum EImageView {
  list = "list",
  details = "details",
  tiles = "tiles",
  largeImages = "largeImages",
  smallImages = "smallImages",
  mediumImages = "mediumImages",
}

export interface IGrecoClient {
  id: number;
  internalNumber: number;
  name: string;
  countryCodeId: number;
  currencyCodeId: number;
  isCompany?: boolean;
  label?: string;
  value?: string;
  clientInternalNumberGos?: number;
  currencyCode?: string;
}

export interface IInsurer {
  Id: number;
  InternalNumber: number;
  Name: string;
  CountryCodeId: number;
  IsCompany: boolean;
}

export interface ICommonAttributes {
  rowVersion?: string;
  backgroundPictureName?: string;
  backgroundPictureContent?: string;
  backgroundPictureMimeType?: string;
  backgroundPicturePath?: string;
  lastModifiedAt?: string;
  lastModifiedByUserId?: string;
  lastModifiedByUserName?: string;
  lastModifiedByUserEmail?: string;
  createdAt?: string;
  createdByUserId?: string;
  createdByUserName?: string;
  createdByUserEmail?: string;
}
